import { IAzureFieldType, IAzureProject, OptionType } from '@evinced-private/ui-common';

import { AZURE_FORM_ACTION_TYPES } from './action-types';

export type AzureFormAction =
	| {
			type: typeof AZURE_FORM_ACTION_TYPES.ORGANIZATION_RESOLVED;
			host: string;
			projects: IAzureProject[];
			selectedProject: OptionType[];
	  }
	| {
			type: typeof AZURE_FORM_ACTION_TYPES.PROJECT_DATA_LOADED;
			projects: IAzureProject[];
			issueTypes: OptionType[];
			selectedIssueType: OptionType;
			fields: Record<string, IAzureFieldType>;
	  }
	| {
			type: typeof AZURE_FORM_ACTION_TYPES.PROJECT_SELECTED;
			host: string;
			selectedProject: OptionType[];
	  }
	| { type: typeof AZURE_FORM_ACTION_TYPES.ISSUE_TYPE_SELECTED; selectedIssueType: OptionType }
	| {
			type: typeof AZURE_FORM_ACTION_TYPES.ISSUE_DATA_UPDATED;
			fields: Record<string, IAzureFieldType>;
			screenshotUrl?: string;
	  }
	| { type: typeof AZURE_FORM_ACTION_TYPES.FIELD_CHANGED; field: IAzureFieldType };

export const organizationResolved = (
	host: string,
	projects: IAzureProject[],
	selectedProject: OptionType[]
): AzureFormAction => ({
	type: AZURE_FORM_ACTION_TYPES.ORGANIZATION_RESOLVED,
	host,
	projects,
	selectedProject
});

export const projectDataLoaded = (
	projects: IAzureProject[],
	issueTypes: OptionType[],
	selectedIssueType: OptionType,
	fields: Record<string, IAzureFieldType>
): AzureFormAction => ({
	type: AZURE_FORM_ACTION_TYPES.PROJECT_DATA_LOADED,
	projects,
	issueTypes,
	selectedIssueType,
	fields
});

export const projectSelected = (host: string, selectedProject: OptionType[]): AzureFormAction => ({
	type: AZURE_FORM_ACTION_TYPES.PROJECT_SELECTED,
	host,
	selectedProject
});

export const issueTypeSelected = (selectedIssueType: OptionType): AzureFormAction => ({
	type: AZURE_FORM_ACTION_TYPES.ISSUE_TYPE_SELECTED,
	selectedIssueType
});

export const issueDataUpdated = (
	fields: Record<string, IAzureFieldType>,
	screenshotUrl?: string
): AzureFormAction => ({
	type: AZURE_FORM_ACTION_TYPES.ISSUE_DATA_UPDATED,
	fields,
	screenshotUrl
});

export const fieldChanged = (field: IAzureFieldType): AzureFormAction => ({
	type: AZURE_FORM_ACTION_TYPES.FIELD_CHANGED,
	field
});
